import resolve from '../../../modules/api/resolve';
import { apiPost, apiStore } from '../../../modules/apiHelper';
import { isStaleData, now } from '../../../modules/dataHelper';

export default {
  // ! adding this action here because idk where to add it to
  async companyRegions(context, companyId) {
    const [regionsStoreExpiry, regionsStoreData] = await apiStore.getItem(`regions/${companyId}`) || [0, []];

    if ((Array.isArray(regionsStoreData) && regionsStoreData.length) && !isStaleData(regionsStoreExpiry)) return regionsStoreData;

    const companyIdFormData = new FormData();
    companyIdFormData.set('companyid', companyId);

    const regions = await resolve(apiPost('regions', companyIdFormData, 30));

    if (regions) {
      await apiStore.setItem(`regions/${companyId}`, [now(), regions?.regions]);

      return regions?.regions || [];
    }

    return [];
  },
};
